import { getService } from "~/lib/services/services-manager";
import {Customisation} from "~/lib/models/customisation";
import { isUuid } from "~/lib/helpers";

export async function getPublicCustomisation(clientUuid:string) : Promise<Customisation> {
  const url = `/clients/customisation/public/${clientUuid && isUuid(clientUuid) ? clientUuid : ""}`;
  const response = await getService("server-app").get(url);
  return Customisation.fromPayload(response.data.customisation);
}